import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.contentTargets.forEach((content) => content.classList.add("hidden"));
  }

  toggle(event) {
    const button = event.currentTarget;
    const content = button.nextElementSibling;
    const icon = button.querySelector("svg");

    // Toggle content visibility
    content.classList.toggle("hidden");

    // Rotate icon
    icon.classList.toggle("rotate-180");

    // Animate transitions
    if (content.classList.contains("hidden")) {
      content.style.maxHeight = "0";
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }
}
